import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Tabs } from '../utils/Tabs';
import { TabsContainer } from '../statistics/styles';
import { ProductGroupsPage } from '../product-groups/product-groups-page';
import { wfpFormat } from '../utils/utils';
import { ProductManagementPage } from '../product-management/product-management.page';
import { ProductsListPage } from './ProductsListPage';
import BreadCrumbs from '../utils/BreadCrumbs';
import { AppConfigActionTypes } from '../app/appConfig';
import State from '../app/store/state';
import { ProductTabs } from './helpers';
import { ProductMobileUIGroups } from './ProductMobileUI/ProductMobileUIGroups';
import { useLocation } from '../common/hooks/useLocation';
import { successAction } from '../utils/notifications';
import { hasFeatureAccess } from '../login/auth';
import { ManagerPermission } from '../permission-profiles/permission';

export const ProductsPageContainer = function ProductsPageContainer() {
    const dispatch = useDispatch();
    const location = useLocation<{ flashSuccess?: string }>();
    const auth = useSelector((state: State) => state.auth);
    const tab = useSelector((state: State) => state.appConfig.productManagementConfig.productsActiveTab);
    const canReadProducts = hasFeatureAccess(auth, ManagerPermission.productsRead);
    const canViewPrices = hasFeatureAccess(auth, ManagerPermission.productGroupPricesView);
    // Products / Groups / MobileGroups require productsRead (entity-side data).
    // Prices requires productGroupPricesView. A user with only price-view sees just the Prices tab.
    const tabs = Object.values(ProductTabs).filter((t) => {
        if (t === ProductTabs.Prices) return canViewPrices;
        return canReadProducts;
    });
    const activeTab = tab && tabs.includes(tab) ? tab : tabs[0];

    const handleClick = (tab: string) => dispatch({ type: AppConfigActionTypes.changeProductTab, payload: tab });

    useEffect(() => {
        if (location?.state?.flashSuccess) {
            dispatch(successAction(location.state.flashSuccess));
        }
    }, []);

    return (
        <main>
            <BreadCrumbs path="/products" />
            <div className="row">
                <h3 className="col-sm-4">Products</h3>
            </div>
            {tabs.length > 1 && (
                <TabsContainer>
                    <Tabs active={activeTab}>
                        {tabs.map((tab) => (
                            <Tabs.Item key={tab} label={tab} onClick={() => handleClick(tab)}>
                                {wfpFormat(tab)}
                            </Tabs.Item>
                        ))}
                    </Tabs>
                </TabsContainer>
            )}
            {activeTab && <Products active={activeTab} />}
        </main>
    );
};

function Products({ active }: { active: ProductTabs }) {
    switch (active) {
        case ProductTabs.Products:
            return <ProductsListPage />;
        case ProductTabs.MobileGroups:
            return <ProductMobileUIGroups />;
        case ProductTabs.Groups:
            return <ProductGroupsPage />;
        case ProductTabs.Prices:
            return <ProductManagementPage />;
        default:
            return <ProductsListPage />; // Default to Products tab
    }
}
